import { Component, Input } from '@angular/core';
import { Transaction } from '../../models/response-transaction-data';
import { CommonModule } from '@angular/common';
import { TablePaginationComponent } from 'src/app/pages/common/table-pagination/table-pagination.component';

@Component({
  selector: 'app-response-transactions-data',
  standalone: true,
  imports: [CommonModule, TablePaginationComponent],
  templateUrl: './response-transactions-data.component.html'
})
export class ResponseTransactionsDataComponent {
    @Input() response: Transaction[]=[];
     tableData:Transaction[]=[];
     updateRecord(data:Transaction[]){
          setTimeout(() => {
            this.tableData = data;
          }, 0);
        }
}
